(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('SoopifyPlanController', SoopifyPlanController);

    SoopifyPlanController.$inject = ['$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'Planning'];
    
    function SoopifyPlanController($uibModalInstance, parameters, SoopkitchenUtils, Planning) {

        var vm = this;
        vm.labelToSoopify = parameters.labelToSoopify;
        vm.internalVersionToSoopify = parameters.internalVersionToSoopify;
        vm.planLabel = null;
        vm.soopTypes = [];
        vm.selectedSoopType = null;
        vm.selectedSoopLeadInstrument = null;
        vm.instruments = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI', 'EPD', 'MAG', 'RPW', 'SWA'];
        vm.save = save;
        vm.clear = clear;
        
        loadSoopTypes();
        
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            Planning.soopify(
                {
                    planLabel: vm.planLabel,
                    leadInstrument: vm.selectedSoopLeadInstrument,
                    soopType: vm.selectedSoopType,
                    planLabelToSoopify : vm.labelToSoopify,
                    internalVersionToSoopify : vm.internalVersionToSoopify,
                },
                function successCallback(data) {
                    SoopkitchenUtils.updatePlanFromDialog(data);
                    $uibModalInstance.dismiss('cancel');
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }
        function loadSoopTypes() {
            Planning.getSoopTypes(
                {},
                function successCallback(data, status, headers, config) {
                    if (data) {
                        data = angular.fromJson(data);
                        vm.soopTypes = [];
                        vm.soopTypes.push("");
                        data.forEach(function (item, index) {
                            vm.soopTypes.push(item);
                        });
                        vm.selectedSoopType = vm.soopTypes[0];
                    }
                },
                function errorCallback(response) {
                });
        }
    }
})();
